export default "__VITE_ASSET__BQS89oWR__"